import script from "./product-audit-list.vue?vue&type=script&setup=true&lang=js"
export * from "./product-audit-list.vue?vue&type=script&setup=true&lang=js"

import "./product-audit-list.vue?vue&type=style&index=0&id=26df9466&lang=scss&scoped=true"
import "./product-audit-list.vue?vue&type=style&index=1&id=26df9466&lang=css"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26df9466"]])

export default __exports__